import React from 'react';
import { connect } from 'react-redux';
import { MenuItemLink, getResources } from 'admin-on-rest';
import CallMade from 'material-ui/svg-icons/communication/call-made';
import AccountBalance from 'material-ui/svg-icons/action/account-balance-wallet';
import ChartOutlined from 'material-ui/svg-icons/editor/insert-chart';
import Place from 'material-ui/svg-icons/maps/place';
import SwapHoriz from 'material-ui/svg-icons/action/swap-horiz';
import TrendingUp from 'material-ui/svg-icons/action/trending-up';
import Assignment from 'material-ui/svg-icons/action/assignment';
import Warning from 'material-ui/svg-icons/alert/warning';
import CallEnd from 'material-ui/svg-icons/communication/call-end';

const styles = {
  sidebar: {
    paddingTop: '12px',
  },
  sectionLabel: {
    fontSize: '10px',
    fontWeight: 600,
    letterSpacing: '0.1em',
    textTransform: 'uppercase',
    color: '#64748b',
    padding: '16px 24px 6px',
    fontFamily: '"Inter", system-ui, sans-serif',
  },
  link: {
    fontWeight: '500',
    fontSize: '13px',
    textAlign: 'left',
    textOverflow: 'ellipsis',
    color: '#94a3b8',
    fontFamily: '"Inter", "SF Pro Display", system-ui, -apple-system, sans-serif',
    borderRadius: '6px',
    transition: 'all 0.15s ease',
  },
  icon: {
    color: '#64748b',
    width: 20,
    height: 20,
  },
};

const Menu = ({ resources, onMenuTap, logout }) => (
  <div style={styles.sidebar}>
    <div style={styles.sectionLabel}>Overview</div>
    <MenuItemLink style={styles.link} to="/" primaryText="Dashboard"
      onClick={onMenuTap} leftIcon={<AccountBalance style={styles.icon}/>} />
    <MenuItemLink style={styles.link} to="/subscriber-activity"
      primaryText="Subscriber Activity" onClick={onMenuTap} leftIcon={<TrendingUp style={styles.icon}/>}/>

    <div style={styles.sectionLabel}>Numbers</div>
    <MenuItemLink style={styles.link} to="/number-assignment"
      primaryText="Number Assignment" onClick={onMenuTap} leftIcon={<Assignment style={styles.icon}/>}/>
    <MenuItemLink style={styles.link} to="/numbers-cleanup"
      primaryText="Numbers Cleanup" onClick={onMenuTap} leftIcon={<CallMade style={styles.icon}/>}/>

    <div style={styles.sectionLabel}>Analytics</div>
    <MenuItemLink style={styles.link} to="/conference-geolocation"
      primaryText="Geolocation" onClick={onMenuTap} leftIcon={<Place style={styles.icon}/>}/>
    <MenuItemLink style={styles.link} to="/conference-stats"
      primaryText="Conference Stats" onClick={onMenuTap} leftIcon={<ChartOutlined style={styles.icon}/>}/>

    <div style={styles.sectionLabel}>Reports</div>
    <MenuItemLink style={styles.link} to="/delinquency-report"
      primaryText="Delinquency" onClick={onMenuTap} leftIcon={<Warning style={styles.icon}/>}/>
    <MenuItemLink style={styles.link} to="/hangup-report"
      primaryText="Hangup Report" onClick={onMenuTap} leftIcon={<CallEnd style={styles.icon}/>}/>

    <div style={styles.sectionLabel}>Tools</div>
    <MenuItemLink style={styles.link} to="/node-cc-migration"
      primaryText="node-cc Migration" onClick={onMenuTap} leftIcon={<SwapHoriz style={styles.icon}/>}/>

    <div style={{marginTop: '16px', borderTop: '1px solid #1e293b', paddingTop: '8px'}}>
      {logout}
    </div>
  </div>
);

const mapStateToProps = state => ({
    resources: getResources(state),
})
export default connect(mapStateToProps)(Menu);



// WEBPACK FOOTER //
// ./src/Menu.js